module.exports = __webpack_public_path__ + "media/images/university_logos/University-of-Edinburgh-ad24f10feadcc2a9a4e8393497de5fdb.svg";